import { Loader } from 'ccs-ui-components';
import { useState } from 'react';

const useLoader = () => {
  const [state, setState] = useState<boolean>(false);

  const show = () => {
    setState(true);
  };
  const hide = () => {
    setState(false);
  };

  const render = () => (
    <Loader show={state} />
  );

  return { show, hide, render };
};

export default useLoader;
